import { FiChevronRight, FiFlag } from "react-icons/fi";
import styled from "styled-components";

import FlexBox from "../FlexBox";
import {
  DAVYS_GREY_200,
  DAVYS_GREY_600,
  DAVYS_GREY_800,
  white,
} from "../colors";

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 999;
`;

const Container = styled(FlexBox)`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${white};
  border-radius: 1rem 1rem 0 0;
  padding: 1rem 0;
  flex-direction: column;
  z-index: 1000;

  animation: slide-up 0.25s ease-out;

  @keyframes slide-up {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }
`;

const Option = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 1rem 1.5rem;
  border: none;
  background: transparent;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};

  &:hover {
    background: ${({ disabled }) =>
      disabled ? "transparent" : DAVYS_GREY_200};
  }
`;

const Label = styled.span`
  flex: 1;
  margin-left: ${({ hasIcon }) => (hasIcon ? "0.75rem" : "0")};
  text-align: left;
  color: ${({ disabled }) => (disabled ? DAVYS_GREY_600 : DAVYS_GREY_800)};
  font-size: 1rem;
  font-weight: 500;
`;

const ReportBottomDrawer = ({ onClose, onReport, isReported = false }) => {
  const handleClick = () => {
    if (isReported) return;

    onReport?.();
    onClose?.();
  };

  return (
    <>
      <Backdrop onClick={onClose} />

      <Container>
        <Option onClick={handleClick} disabled={isReported} type="button">
          {!isReported && <FiFlag size={18} />}

          <Label hasIcon={!isReported} disabled={isReported}>
            {isReported ? "Already reported" : "Report"}
          </Label>

          {!isReported && <FiChevronRight size={18} />}
        </Option>
      </Container>
    </>
  );
};

export default ReportBottomDrawer;
